<template>
  <i-modal :title="LANG.selectTargetSystem">
    <div class="responsive-table">
      <table class="filelist" >
        <tbody>
          <tr v-for="{target_id, live_uri} in targets" :key="target_id">
            <th><span class="copypage-title-cell i-css-ellipsis">{{ target_id }}</span></th>
            <td>
              <a :href="live_uri">
                <i class="fa5 fas fa-arrow" name="arrow-up-right-from-square"></i>
                {{ live_uri }}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <template #footer>
      <i-button variant="secondary" @click="$emit('update:show', false)">
        {{ LANG.cancel }}
      </i-button>
    </template>
  </i-modal>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import useSWRV from 'swrv';
import { apiFetcher, url } from '@/utils/useData';

export default defineComponent({
  props: {
    document: {
      default: () => ({}),
      type: Object,
    },
  },
  setup(props, { attrs }) {
    const { data: targets } = useSWRV(
      () => attrs.show && url('/data/documents/live_uri', { doc_id: props.document.nodeId }),
      apiFetcher,
    );

    const store = useStore();
    return {
      targets,
      LANG: computed(() => store.state.LANG),
    };
  },
});
</script>

<style scoped lang="scss">
.filelist {
  min-width: 100%;
  a {
    color: #1c519c;
  }
  th, td {
    white-space: nowrap;
    padding-right: 15px;
    text-align: left;
  }
  th {
    font-weight: bold;
    font-size: 13px;
    font-family: $font-family-regular;
  }
}
.copypage-title-cell {
  display: block;
  max-width: 160px;
}
</style>
